import React from 'react'
import Navabar from './Navigation'

function Technology() {
  return (
    <div>

      Technology</div>
  )
}

export default Technology